//translated from https://github.com/thisispete/LFO
const float LFO_PI = 3.14159265; 

float getSin (in float time, in float min, in float max, in float interval) {
  float perc = mod(time , interval) / interval;
  return min + (1. + sin((perc * 360. * LFO_PI) / 180.)) * ((max - min) / 2.);
}  

float getSin (in float time, in float min, in float max, in float interval, in float offset) {
  float perc = mod(time + offset, interval) / interval;
  return min + (1. + sin((perc * 360. * LFO_PI) / 180.)) * ((max - min) / 2.);
}  

float getCos (in float time, in float min, in float max, in float interval) {
  float perc = mod(time , interval) / interval;
  return min + (1. + cos((perc * 360. * LFO_PI) / 180.)) * ((max - min) / 2.);
}  

float getCos (in float time, in float min, in float max, in float interval, in float offset) {
  float perc = mod(time + offset, interval) / interval;
  return min + (1. + cos((perc * 360. * LFO_PI) / 180.)) * ((max - min) / 2.);
}  

float getTriangle (in float time, in float min, in float max, in float interval) {
  float perc = mod(time , interval) / interval;
  return abs(perc - 0.5) * (max - min) * 2. + min;
}

float getTriangle (in float time, in float min, in float max, in float interval, in float offset) {
  float perc = mod(time + offset, interval) / interval;
  return abs(perc - 0.5) * (max - min) * 2. + min;
}

float getSaw (in float time, in float min, in float max, in float interval) {
  float perc = mod(time , interval) / interval;
  return perc * (max - min) + min;
}

float getSaw (in float time, in float min, in float max, in float interval, in float offset) {
  float perc = mod(time + offset, interval) / interval;
  return perc * (max - min) + min;
}

//TODO: fix: throws errors
// float getSquare (in float time, in float min, in float max, in float interval) {
//   float perc = mod(time , interval) / interval;
//   return round(perc) * (max - min) + min;
// }

// float getSquare (in float time, in float min, in float max, in float interval, in float offset) {
//   float perc = mod(time + offset, interval) / interval;
//   return round(perc) * (max - min) + min;
// }
